// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleWatchInterview_root__mq2EQ","title":"ArticleWatchInterview_title__Me_q3","card":"ArticleWatchInterview_card__WFnUi"};